module.exports = __webpack_public_path__ + "media/horse.d1f9bdfb.mp3";